import React, { useState } from "react";
import CustomPagination from "../../../../components/CustomPagination";
import { Box,Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import Modal from "../../../../components/Modal";
import { DeleteOutlineSharp, Edit } from "@mui/icons-material";
import styles from "./style";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../../../utils/DateFormat";

const SaleItemList = ({data}) => {
  const [open, setOpen] = useState(false)
  const navigate = useNavigate();
  //   const [deleteId, setDeleteId] = useState()

  const deleteData = () => {
    // setDeleteId(id)
  }

  const handleDeleteItem = () => {
    // deleteOtherIncome(deleteId);
    setOpen(false);
  };

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={styles.TableHead}>Sale Name</TableCell>
              <TableCell sx={styles.TableHead}>Start Date</TableCell>
              <TableCell sx={styles.TableHead}>End Date</TableCell>
              <TableCell sx={styles.TableHead}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(!data?.income||!data) ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Typography variant="h6">No data</Typography>
                </TableCell>
              </TableRow>
            ) : (
              data?.income?.map((item, index) => (
                <TableRow key={index}>
                  <TableCell sx={styles.tableData}>
                    {item?.name}
                  </TableCell>
                  <TableCell sx={styles.tableData}>{item?.incomeType}</TableCell>
                  <TableCell sx={styles.tableData}>
                    {item?.amount}
                  </TableCell>
                  <TableCell sx={styles.tableData}>{formatDate(new Date(item.date), "MMM d, yyyy")}</TableCell>
                  <TableCell sx={styles.tableData}>{item?.receivedVia}</TableCell>
                  <TableCell sx={styles.tableAlign}>
                    <Box>
                      <Edit
                        onClick={() => navigate("/dashboard/viewOtherIncome",{state:{item}}) }
                      />
                    </Box>
                    <Box sx={{ mx: 1.5 }}>
                      <DeleteOutlineSharp
                        sx={{ color: "#ff0000" }}
                        onClick={() => {
                          deleteData(item?._id), setOpen(true);
                        }}
                      />
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
        <CustomPagination />
      </TableContainer>
      <Modal
        open={open}
        setOpen={setOpen}
        deletetText={"Delete"}
        cancelText={"Cancel"}
        title={"Delete Bank"}
        handleDelete={handleDeleteItem}
      >
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>
        </Box>
      </Modal>
    </>
  );
};

export default SaleItemList;
